/**
 * Labstep
 *
 * @module components/Resource/Breadcrumb
 * @desc Breadcrumb for Resource
 */

import { EntityTemplateBreadcrumbShow as EntityEntityTemplateBreadcrumbShow } from 'labstep-web/components/Entity/Template/Breadcrumb/Show';
import type React from 'react';
import type { IResourceBreadcrumbProps } from './types';

export const ResourceBreadcrumb: React.FC<
  IResourceBreadcrumbProps
> = ({ resource }) => (
  <EntityEntityTemplateBreadcrumbShow entity={resource} />
);
